export default __webpack_public_path__ + "assets/images/0202b27716522c67cc9cc7b001c6a0ce.png";